
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropReceipt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DropReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drop"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"associated_players"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"running"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"submitted_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quote_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":191}};
    doc.loc.source = {"body":"fragment DropReceipt on DropReceipt {\n  drop {\n    asset {\n      name\n      associated_players {\n        name\n      }\n    }\n    running\n  }\n  submitted_time\n  quote_amount\n  transaction_id\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
